
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class DismantlingReturnGrid extends Serenity.EntityGrid<DismantlingReturnRow, any> {
        protected getColumnsKey() { return 'Production.DismantlingReturn'; }
        protected getDialogType() { return DismantlingReturnDialog; }
        protected getIdProperty() { return DismantlingReturnRow.idProperty; }
        protected getInsertPermission() { return DismantlingReturnRow.insertPermission; }
        protected getLocalTextPrefix() { return DismantlingReturnRow.localTextPrefix; }
        protected getService() { return DismantlingReturnService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        protected addButtonClick() {

            let now = new Date();
            var userDefinition = Q.Authorization.userDefinition;
            var voucherNo = FormatHelper.GetVoucherNo(62);
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[62].AutoPosting;
            this.editItem(<DismantlingReturnRow>{
                VoucherNo: voucherNo,
                TransDate: now.toDateString(),
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId, 
                VoucherTypeId: 62,
                EmployeeId: userDefinition.UserId,
                AutoPosting: autoposting

            });
        }
    }
}